export const pasteStyle = {
  '& .copy-paste-container': {
    '& .form-group': {
      padding: 0,
      margin: 0,
      '& ul': {
        marginBottom: 0,
        '& .checkbox': {
          paddingTop: 0,
          '& label': {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
      '& .copyPaste-radio-topBottomPadding': {
        margin: {
          top: 3,
          bottom: 3,
        },
      },
      '& .date-picker-within-radio': {
        margin: {
          top: -6,
          bottom: -4,
          left: -15,
        },
      },
      '& .copyPaste-radio-label': {
        margin: {
          top: 4,
          right: -9,
        },
      },
      '& .col-sm-1': {
        width: 100,
      },
      '& .col-sm-2': {
        width: 140,
      },
    },
  },
};
